import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns || 'none'};
  grid-template-rows: ${props => props.rows || 'auto'};
  gap: ${props => props.gap || '20px'};
`;
